module.exports = "Click “Resize Image” to generate the cropped version of your image"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/crop-images-how-to-step-four.md
// module id = 1148
// module chunks = 0